module.exports = __webpack_public_path__ + "dcc07bcfcd475f34f20b2c1265bd1265.woff2";